import { relayStylePagination } from '@apollo/client/utilities';

export const cacheTypePolicies = {
  typePolicies: {
    Image: {
      keyFields: ['url'],
    },
    MapArea: {
      fields: {
        catches: relayStylePagination(['first']),
      },
    },
    Query: {
      fields: {
        mapArea: {
          keyArgs: ['boundingBox'],
        },
      },
    },
  },
};
